import { UseQueryResult } from "@tanstack/react-query";
import { Modal, ProgressBar, Spinner } from "react-bootstrap";
import { NBSP } from "../helpers/util";

//this helps with react-query: it's a centralized place to return a spinner if any query is loading, and to return
//any error messages if any queries fail. Otherwise, it returns null.
//components that use a query should call this, and if doesn't return null, return its value.
export function QueryStatus(...queries: UseQueryResult[]) {
  if (queries.every((q) => q.isSuccess)) return null;

  if (queries.some((q) => q.isLoading)) {
    return <Spinner animation="border" variant="primary" />;
  }

  return (
    <div>
      {queries
        .filter((q: UseQueryResult) => !!q.error)
        .map((q, idx) => (
          //@ts-ignore: q.error is known enough to have a message property
          <span key={idx}>{q.error.message}</span>
        ))}
    </div>
  );
}

export function QueryStatusBar(...queries: UseQueryResult[]) {
  if (queries.every((q) => q.isSuccess)) return null;

  <Modal show={!!queries.filter((q) => !q.isSuccess).length}>
    <Modal.Header>Loading...</Modal.Header>
    <ProgressBar animated striped now={queries.filter((q) => q.isSuccess).length} max={queries.length} />
    <Modal.Header>{NBSP}</Modal.Header>
  </Modal>;

  return (
    <div>
      {queries
        .filter((q: UseQueryResult) => !!q.error)
        .map((q, idx) => (
          //@ts-ignore: q.error is known enough to have a message property
          <span key={idx}>{q.error.message}</span>
        ))}
    </div>
  );
}
